<template>
  <div>
    <vuejs-datepicker
      v-model="date"
      :language="ptBR"
      :bootstrap-styling="true"
      :format="customFormatter"
      :disabledDates="disabledDates"
      @input="changedDate"
      placeholder="DD/MM/AAAA"
      :clear-button="true"
      :clear-button-icon="'fa fa-close'" />
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import ptBR from 'vuejs-datepicker/dist/locale/translations/pt-BR'
import moment from 'moment'

export default {
  name: 'Datepicker',
  components: {
    'vuejs-datepicker': Datepicker
  },
  props: {
    val: {
      type: [String, Date]
    },
    disabledDates: {
      type: Object
    }
  },
  data () {
    return {
      ptBR: ptBR,
      date: this.val
    }
  },
  watch: {
    val (res) {
      if (this.val && typeof this.val === 'string') {
        this.stringToDate()
      }
    }
  },
  methods: {
    customFormatter (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    changedDate () {
      this.$emit('changedDate', this.customFormatter(this.date))
    },
    stringToDate () {
      this.date = new Date(this.val.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3'))
    }
  }
}
</script>

<style lang="scss">
.vdp-datepicker {

  .input-group {
    display: block;
    position: relative;

    .input-group-append {
      border: 1px solid #e5e6e7;
      height: 34px;
      line-height: 32px;
      padding: 0 10px;
      position: absolute;
      right: 0;
      top: 0;
      z-index: 2000;
    }
  }
}

.vdp-datepicker__calendar {
  width: 240px !important;
}

.vdp-datepicker__calendar > div > .cell:not(.blank):not(.disabled).day:hover,
.vdp-datepicker__calendar > div > .cell:not(.blank):not(.disabled).month:hover,
.vdp-datepicker__calendar > div > .cell:not(.blank):not(.disabled).year:hover {
  border: 1px solid #1ab394;
}

.vdp-datepicker__calendar .cell.selected {
  background: #1ab394 !important;
  color: #fff !important;
  font-weight: bold !important;
}

.vdp-datepicker__calendar > div > .cell {
  display: inline-block;
  padding: 0 5px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  vertical-align: middle;
  border: 1px solid transparent;
}

.vdp-datepicker__calendar > div > .cell.today {
  color: #1ab394;
  font-weight: bold;
}

.vdp-datepicker__calendar > div > .cell.today.selected {
  color: #fff;
}

.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
  border: 1px solid #1ab394 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/datepicker/Datepicker.vue